import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ShieldCheck, TrendingDown, Lightbulb } from "lucide-react";

export default function PriceGuide() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/data/price-guide").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-6 py-12 sm:px-10">
      <p className="overline text-primary">Fair price guidance</p>
      <h1 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">Never overpay in Morocco</h1>
      <p className="mt-2 max-w-2xl text-muted-foreground">
        Bargaining is part of the culture. Know the real local price before you start, and haggle with confidence.
      </p>

      <div className="mt-8 flex flex-wrap gap-4 text-sm">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary/10 px-4 py-2 text-secondary">
          <ShieldCheck className="h-4 w-4" /> Fair local price
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-destructive/10 px-4 py-2 text-destructive">
          <TrendingDown className="h-4 w-4" /> Tourist-trap price
        </span>
      </div>

      <div className="mt-8 space-y-4" data-testid="price-guide-list">
        {items.map((it, i) => (
          <div key={i} className="rounded-2xl border bg-card p-6 transition-shadow hover:shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <h3 className="font-display text-lg font-semibold">{it.item}</h3>
              <div className="flex gap-3">
                <div className="rounded-xl bg-secondary/10 px-4 py-2 text-center">
                  <p className="text-[10px] uppercase tracking-wide text-secondary">Fair</p>
                  <p className="font-semibold text-secondary">{it.fair_price}</p>
                </div>
                <div className="rounded-xl bg-destructive/10 px-4 py-2 text-center">
                  <p className="text-[10px] uppercase tracking-wide text-destructive">Trap</p>
                  <p className="font-semibold text-destructive">{it.tourist_trap}</p>
                </div>
              </div>
            </div>
            <p className="mt-4 flex items-start gap-2 rounded-lg bg-accent/10 px-3 py-2 text-sm">
              <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-accent" /> {it.tip}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
